import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../type';

export const adverseEventSelector = (state: RootState) => state.adverseEvent;

export const isAdverseEventSelector = createSelector(
  adverseEventSelector,
  (state) => state
);
